"use strict";function departmentsPicker$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.departmentsPicker$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.contact.departmentsPicker";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.pc]={vs:"4.2.5"},_a[ddSdk_1.ENV_ENUM.ios]={vs:"3.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"3.0"},_a)),exports.departmentsPicker$=departmentsPicker$,exports.default=departmentsPicker$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/contact/departmentsPicker.js
// module id = 933
// module chunks = 106